export default {
    apiKey: "AIzaSyC9Vsa6Md62rE_fK8cM5u5R0_L1ZQrn8iE",
    authDomain: "tayo-c846e.firebaseapp.com",
    databaseURL: "https://tayo-c846e.firebaseio.com",
    projectId: "tayo-c846e",
    storageBucket: "tayo-c846e.appspot.com",
    messagingSenderId: "91886545753",
    appId: "1:91886545753:web:9788dfb39345216780ba48",
    measurementId: "G-F0QNKTGDH8"
}